import React, { useState, useMemo, ReactNode } from 'react';
import { Button } from '@nextui-org/react';
import { useTranslation } from '@/layers/presentation/i18n/client';

interface PaginatorProps<T> {
  list: T[];
  pageSize?: number;
  children: (items: T[]) => ReactNode;
  className?: string;
  buttonClassName?: string;
}

export default function Paginator<T>({
  list,
  pageSize = 10,
  children,
  className = '',
  buttonClassName = 'mt-8',
}: PaginatorProps<T>) {
  const { t } = useTranslation();
  const [visibleCount, setVisibleCount] = useState(pageSize);

  const paginatedItems = useMemo(() => {
    return list.slice(0, visibleCount);
  }, [list, visibleCount]);

  const handleShowMore = () => {
    setVisibleCount(prev => prev + pageSize);
  };

  return (
    <div className={className}>
      {children(paginatedItems)}
      {list.length > visibleCount && (
        <div className={`flex justify-center ${buttonClassName}`}>
          <Button color="primary" onPress={handleShowMore}>
            {t('components:paginator.showMore')}
          </Button>
        </div>
      )}
    </div>
  );
}
